var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _g2, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUangUsahaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 34,
    viewBox: "0 0 44 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37769 3.92424C6.37769 1.75694 8.18217 0 10.4081 0H33.2472C35.4732 0 37.2777 1.75694 37.2777 3.92424V22.4009C37.2777 24.5682 35.4732 26.3251 33.2472 26.3251H10.4081C8.18217 26.3251 6.37769 24.5682 6.37769 22.4009V3.92424Z",
    fill: "#1E54A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7471 4.74982C10.7471 3.12435 12.1004 1.80664 13.7699 1.80664H37.2808C38.9502 1.80664 40.3036 3.12435 40.3036 4.74982V26.6602C40.3036 28.2857 38.9502 29.6034 37.2808 29.6034H13.7699C12.1004 29.6034 10.7471 28.2857 10.7471 26.6602V4.74982Z",
    fill: "#E4C342"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37769 8.17522C6.37769 6.00792 8.18217 4.25098 10.4081 4.25098H38.6211C40.8471 4.25098 42.6516 6.00792 42.6516 8.17522V28.287C42.6516 30.4543 40.8471 32.2112 38.6211 32.2112H10.4081C8.18217 32.2112 6.37769 30.4543 6.37769 28.287V8.17522Z",
    fill: "#1E54A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_932_21177",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 4,
    width: 36,
    height: 30
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38403 8.42544C6.38403 6.11941 8.13509 4.25 10.2951 4.25H37.6729C39.8329 4.25 41.584 6.11941 41.584 8.42544V29.8246C41.584 32.1306 39.8329 34 37.6729 34H10.2951C8.13509 34 6.38403 32.1306 6.38403 29.8246V8.42544Z",
    fill: "#1E54A5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_932_21177)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-25.023 43.588C4.80764 47.2853 37.6613 13.1076 48.132 -5.43175L58.5261 -0.819716L26.9472 66.6482L-25.023 43.588Z",
    fill: "#1C3E7B"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0614 14.8863C30.0614 14.3445 30.5125 13.9053 31.069 13.9053H41.9848C43.0977 13.9053 44 14.7837 44 15.8674V19.4646C44 20.5483 43.0977 21.4267 41.9848 21.4267H31.069C30.5125 21.4267 30.0614 20.9875 30.0614 20.4457V14.8863Z",
    fill: "#4A76BE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1041 17.5747C36.1041 18.6132 35.2394 19.4551 34.1728 19.4551C33.1062 19.4551 32.2416 18.6132 32.2416 17.5747C32.2416 16.5362 33.1062 15.6943 34.1728 15.6943C35.2394 15.6943 36.1041 16.5362 36.1041 17.5747Z",
    fill: "#FAEFE2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8087 24.8424C18.8087 29.8994 14.5982 33.9989 9.40434 33.9989C4.21047 33.9989 0 29.8994 0 24.8424C0 19.7853 4.21047 15.6858 9.40434 15.6858C14.5982 15.6858 18.8087 19.7853 18.8087 24.8424Z",
    fill: "#E08820"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8619 24.8434C16.8619 28.8542 13.5226 32.1055 9.40332 32.1055C5.28404 32.1055 1.9447 28.8542 1.9447 24.8434C1.9447 20.8327 5.28404 17.5813 9.40332 17.5813C13.5226 17.5813 16.8619 20.8327 16.8619 24.8434Z",
    fill: "#E4C342"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_932_21177",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 17,
    width: 16,
    height: 16
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8619 24.8434C16.8619 28.8542 13.5226 32.1055 9.40332 32.1055C5.28404 32.1055 1.9447 28.8542 1.9447 24.8434C1.9447 20.8327 5.28404 17.5813 9.40332 17.5813C13.5226 17.5813 16.8619 20.8327 16.8619 24.8434Z",
    fill: "#E19C2A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_932_21177)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0 35.882C9.45809 33.3683 14.5096 20.5209 15.047 14.4114H18.8087V35.882H0Z",
    fill: "#E08721"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92588 20.7561C8.36939 20.7561 7.91827 21.1953 7.91827 21.7372V23.8063H5.79313C5.23664 23.8063 4.78552 24.2455 4.78552 24.7874V25.7149C4.78552 26.2567 5.23664 26.696 5.79313 26.696H7.91827V28.6046C7.91827 29.1464 8.36939 29.5857 8.92588 29.5857H9.87852C10.435 29.5857 10.8861 29.1464 10.8861 28.6046V26.696H12.8464C13.4029 26.696 13.854 26.2567 13.854 25.7149V24.7874C13.854 24.2455 13.4029 23.8063 12.8464 23.8063H10.8861V21.7372C10.8861 21.1953 10.435 20.7561 9.87852 20.7561H8.92588Z",
    fill: "#FAEFE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUangUsahaIcon);
export default __webpack_public_path__ + "static/media/uang-usaha-icon.07df60737cab213d421d824f56bb70c4.svg";
export { ForwardRef as ReactComponent };